
















































































































































import INoticeOfLossDetail from '@/store/models/INoticeOfLossDetail';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import IInboundDeliveryNotesDetail from '@/store/models/IInboundDeliveryNotesDetail';
import InboundsNoticeOfLossDeliveryNotesDetailSelector from '@/components/selectors/NoticeOfLoss/InboundsNoticeOfLossDeliveryNotesDetailSelector.vue';
@Component({
    components: {
        Snackbar,
        InboundsNoticeOfLossDeliveryNotesDetailSelector
    }
})
export default class InboundsNoticeOfLossDetailSelector extends Vue {
    searchNoticeOfLossDetail: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'idPallet';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'ListPalletName',
            align: 'start',
            value: 'listPalletName'
        },
        { text: 'Pallet id', value: 'idPallet' },
        { text: 'Cases per pallet', value: 'casesPerPallet' },
        { text: 'Goods per case', value: 'goodsPerCase' },
        { text: 'Total goods', value: 'totalGoods' },
        { text: 'Actions', value: 'actions' }
    ];
    editedIndex : number = -1;
    editedItem : INoticeOfLossDetail = {
        id: "",
        idNoticeOfLoss: "",
        idDeliveryNoteDetail: "",
        idListPallet: "",
        listPalletName: "",
        idPallet: "",
        casesPerPallet: 0,
        goodsPerCase: 0,
        totalGoods: 0
    }
    defaultItem : INoticeOfLossDetail = {
        id: "",
        idNoticeOfLoss: "",
        idDeliveryNoteDetail: "",
        idListPallet: "",
        listPalletName: "",
        idPallet: "",
        casesPerPallet: 0,
        goodsPerCase: 0,
        totalGoods: 0
    }

    @Prop({ type: Array, required: true })
    NoticeOfLossDetailList !: INoticeOfLossDetail[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    InboundDeliveryNotesDetailList !: IInboundDeliveryNotesDetail[];
    @Prop()
    Loading !: boolean;

    selectedNoticeOfLossDetail : INoticeOfLossDetail[] = [];
    selectedInboundsDeliveryNotesDetail : IInboundDeliveryNotesDetail[] | null = null;
    get formTitle() { return this.editedIndex === -1 ? 'New Notice of loss detail' : 'Edit Notice of loss detail'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    getInboundDeliveryNotesDetails() {
        this.selectedNoticeOfLossDetail = [];
        this.selectedInboundsDeliveryNotesDetail = null;
        this.$emit('getInboundDeliveryNotesDetails');
    }

    saveNoticeOfLossDetail () {
        let noticesOfLossDetails : INoticeOfLossDetail[] = [];
        if (this.selectedInboundsDeliveryNotesDetail === null) {
            this.showMessageWarning('Please select a stock to save');
        } else {
            this.selectedInboundsDeliveryNotesDetail.forEach(p => {
                let noticeOfLossDetail : INoticeOfLossDetail = {} as INoticeOfLossDetail;
                noticeOfLossDetail.idDeliveryNoteDetail = p.id;
                noticeOfLossDetail.idListPallet = p.idListPallet;
                noticeOfLossDetail.listPalletName = p.palletName;
                noticeOfLossDetail.idPallet = p.idPallet;
                noticeOfLossDetail.casesPerPallet = p.casesPerPallet;
                noticeOfLossDetail.goodsPerCase = p.goodsPerCase;
                noticeOfLossDetail.totalGoods = p.totalGoods;
                noticesOfLossDetails.push(noticeOfLossDetail);
            });
            this.$emit('saveNoticeOfLossDetail', noticesOfLossDetails);
            this.close();
        }
    }

    deleteNoticeOfLossDetail (noticeOfLossDetail: INoticeOfLossDetail) {
        this.$emit('deleteNoticeOfLossDetail', noticeOfLossDetail);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    select(item : INoticeOfLossDetail) : void {
        let index : number = this.selectedNoticeOfLossDetail.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedNoticeOfLossDetail = [item];
        } else {
            let noticeOfLossDetail = this.selectedNoticeOfLossDetail.find(w => w.id === item.id);
            if (!noticeOfLossDetail) {
                this.selectedNoticeOfLossDetail = [];
            }
        }
    }

    get totalPalletsSelected(): number {
        return this.selectedInboundsDeliveryNotesDetail ? this.selectedInboundsDeliveryNotesDetail.length : 0;
    }

    get totalCasesSelected(): number {
        if (!this.selectedInboundsDeliveryNotesDetail) return 0;
        return this.selectedInboundsDeliveryNotesDetail.reduce((sum, item) => sum + (item.casesPerPallet || 0), 0);
    }

    get totalGoodsSelected(): number {
        if (!this.selectedInboundsDeliveryNotesDetail) return 0;
        return this.selectedInboundsDeliveryNotesDetail.reduce((sum, item) => sum + (item.totalGoods || 0), 0);
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
